import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";

import "./App.css";
import SegmentsPage from "./pages/SegmentsPage";
import ImageUpload from "./pages/ImageUpload";
import Gallery from "./pages/Gallery";
import GlobePage from "./pages/GlobePage"
import HomePage from "./pages/HomePage";
import TestPage from "./pages/TestPage";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/segments" element={<SegmentsPage />} />
        <Route path="/imageupload" element={<ImageUpload />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/globe" element={<GlobePage />} />
        <Route path="/test" element={<TestPage />} />
      </Routes>
    </Router>
  );
}

export default App;
